import { StatusCodes } from 'http-status-codes';
import type { HttpRejection } from '@model/http/rejection';
import type { Store } from 'vuex';

type PrefetchFn = (locale: string) => Promise<void>;

export async function ServerPrefetchLocalizedProbe(store: Store<any>, prefetchFn: PrefetchFn) {
    const { desiredLocale, requestedLocale } = store.state.geolocation;
    const needLocalizedProbe = desiredLocale && desiredLocale !== requestedLocale;

    // If desired locale is different than requested, probe the local resource first
    if (needLocalizedProbe) {
        await store.dispatch('geolocation/updateFinalLocale', desiredLocale);

        try {
            return await prefetchFn(desiredLocale);
        } catch (error) {
            // If probe is failed and it's not 404, re-throw to app-engine
            const suppressedCode = StatusCodes.NOT_FOUND as number;
            const rejectionCode = (error as HttpRejection).httpStatusCode;
            if (rejectionCode !== suppressedCode) {
                throw error;
            }
        }
    }

    // If desired locale is not relevant or probe failed with 404, prefetch the requested instead
    await store.dispatch('geolocation/updateFinalLocale', requestedLocale);

    return prefetchFn(requestedLocale);
}
